import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGoalTaskProgress } from 'shared/hooks/use-goal-task-progress';
import { useNumberFormat } from 'shared/hooks/use-number-format';
import { metricUnitFormatBase } from 'shared/types/metric-template';

import { InsightsCard } from './insights-card';
import { GoalInsightsCardProps } from './types';

export const GoalInsightsTaskCard: React.FC<GoalInsightsCardProps> = ({
  goal,
  startDate,
  endDate,
  hideTimeframeDifference,
  ...rest
}) => {
  const { t } = useTranslation();
  const numberFormat = useNumberFormat();
  const {
    entries: goalProgress,
    target,
    completionPercentage,
    timeframeDifference,
  } = useGoalTaskProgress(goal, { startDate, endDate });

  const unitFormat = `${metricUnitFormatBase} ${t('general.labels.goal-progress.unit-format.tasks.label')}`;

  return (
    <InsightsCard
      goal={goal}
      startDate={startDate}
      endDate={endDate}
      {...rest}
      entries={goalProgress}
      completionPercentage={completionPercentage}
      unitFormat={unitFormat}
      startValue={0}
      target={target}
      isEmpty={!target}
      timeframeDifference={
        hideTimeframeDifference ? undefined : timeframeDifference
      }
      numberFormat={numberFormat}
    />
  );
};
